import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useMemo } from 'react';
import Spinner from '../Spinner';
const SuspenseBoundary = ({ forceLoading, scale, rotation, position, renderOrder, children, color = '#5276F7' }) => {
    const mPlc = useMemo(() => ({
        scale,
        rotation,
        position,
        fillRgba: [227, 227, 227, 1],
        borderRgba: [181, 181, 181, 1],
    }), []);
    const spinnerScale = useMemo(() => {
        const isPortrait = scale[1] > scale[0];
        let spScale = [scale[1] * 0.3, scale[1] * 0.3, 0];
        if (isPortrait)
            spScale = [scale[0] * 0.3, scale[0] * 0.3, 0];
        return spScale;
    }, [scale]);
    const placeholderEntity = (_jsx(Spinner, { opacity: 1, radiansPerFrame: 0.06, color: color, scale: spinnerScale, position: mPlc.position, renderOrder: renderOrder + 2, depthWrite: false }));
    return (_jsx(Suspense, { fallback: placeholderEntity, children: forceLoading ? placeholderEntity : children }));
};
export default SuspenseBoundary;
